module.exports = __webpack_public_path__ + "static/media/grand_mum_please_eat.bb1ac54b.png";